import { useMutation, useQueryClient } from '@tanstack/react-query';
import { resourceApi, type CreateResourceRequest } from '../api/resourceApi';
import { toast } from 'react-hot-toast';

export const useCreateResource = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateResourceRequest) =>
      resourceApi.createResource(data),
    onSuccess: () => {
      toast.success('Resource created successfully');
      queryClient.invalidateQueries({ queryKey: ['resources'] });
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.message || 'Failed to create resource');
    },
  });
};
